import { Link } from 'react-router-dom';
import DynamicFaIcon from '../components/atoms/DynamicFaIcon';
import { AuthLayout, FormAuth, ButtonPrimary } from '../components';
import { useDispatch } from 'react-redux';
import { setLoadingStatus } from '../redux/utlsSlice';
import { useEffect } from 'react';

const Auth = () => {

    const dispatch = useDispatch<any>();



    return (
        <AuthLayout showNavBar={false}>
            <div className="flex justify-center ">
                <img className="my-4" src="/assets/imgs/logo-blue.png" alt="" />
            </div>
            <div className="mb-4">
                <span className="font-bold text-[12px]">Login Akun</span>
            </div>
            <FormAuth />
            <div className="text-[12px] flex text-center justify-center">Atau login dengan</div>
            <div className="flex justfiy-center gap-10 my-3">
                <button
                    onClick={() => { dispatch(setLoadingStatus(true)) }}
                    className="btn w-full flex btn-outline-primary font-bold items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                            fill="#FFC107" />
                        <path
                            d="M3.15332 7.3455L6.43882 9.755C7.32782 7.554 9.48082 6 12.0003 6C13.5298 6 14.9213 6.577 15.9808 7.5195L18.8093 4.691C17.0233 3.0265 14.6343 2 12.0003 2C8.15932 2 4.82832 4.1685 3.15332 7.3455Z"
                            fill="#FF3D00" />
                        <path
                            d="M12.0002 22.0003C14.5832 22.0003 16.9302 21.0118 18.7047 19.4043L15.6097 16.7853C14.5719 17.5745 13.3039 18.0014 12.0002 18.0003C9.39916 18.0003 7.19066 16.3418 6.35866 14.0273L3.09766 16.5398C4.75266 19.7783 8.11366 22.0003 12.0002 22.0003Z"
                            fill="#4CAF50" />
                        <path
                            d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
                            fill="#1976D2" />
                    </svg>
                    <span className='w-full'>Google</span>
                </button>
                <button className="btn btn-block btn-outline-primary font-bold flex gap-4 items-center">
                    <div className="text-lg">
                        <i className="fa-brands fa-facebook-f"></i>
                    </div>
                    <span className="">Facebook</span>
                </button>
            </div>
            <div className="text-[12px] flex justify-center gap-2 mt-5">Belum punya akun? <a href="/register"
                className="text-primary font-bold">
                Daftar Sekarang</a>
            </div>
            <div className="w-full flex justify-center items-center my-3">
                <Link to={'/search-mitra'}>
                    <ButtonPrimary>
                        <div className='flex items-center gap-1'>
                            <DynamicFaIcon name={'FaUsers'} />
                            <span className='text-[12px]'>Cari Data Mitra</span>
                        </div>
                    </ButtonPrimary>
                </Link>
            </div>
        </AuthLayout>
    );
};

export default Auth;